<pa-empty-list icon="pi pi-file-edit" listTitle="У вас пока нет договоров"
  subtitle="Создайте договор, чтобы начать работу с контрагентами и вести документацию." iconSize="80px">
</pa-empty-list>